import { Context } from '@nuxt/types/app'
import { Middleware } from '@nuxt/types'
import MeUseCase from '@/usecases/legacy/auth/MeUseCase'

export const authenticated: Middleware = ({ App, redirect }: Context) => {
  if (!App.legacy.token) {
    redirect('/legacy/login')
  }
}

export const me: Middleware = async ({ App }: Context) => {
  if (!App.legacy.user) {
    await new MeUseCase(App).execute()
  }
}
